import { cx } from '@linaria/core';
import { useCallback } from 'react';
import { header, row } from './row.style.js';
import { jsx } from 'react/jsx-runtime';

function Row(props) {
  const onKeyDown = useCallback(evt => {
    // In case we're attempting to interact with the onClick handler on
    // buttons inside the Row, then this should not fire beforehand
    if (evt.target instanceof HTMLButtonElement) {
      return;
    }
    if (evt.key === " " || evt.key === "Enter") {
      evt.preventDefault();
      props.onClick?.(evt);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.onClick]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    className,
    onClick,
    children,
    sizingCls,
    ...ariaProps
  } = props;
  return /*#__PURE__*/jsx("div", {
    ...ariaProps,
    role: "row",
    className: cx(props.as === "header" ? header : row, props.sizingCls, props.className),
    onClick: props.onClick,
    tabIndex: props.onClick ? 0 : undefined,
    onKeyDown: props.onClick ? onKeyDown : undefined,
    children: props.children
  });
}

export { Row };
//# sourceMappingURL=row.js.map
